import React from 'react'
import kidan from "../../asset/IMG_3130.png"
import "./Home.css"
import { FaTelegramPlane } from "react-icons/fa";
import { VscGithubInverted } from "react-icons/vsc";
import { FaFacebookF } from "react-icons/fa";
import Typical from "react-typical"
import doc from "../../asset/Management.pdf"

function Home() {
  return (
      <div className='home' id='Navbar'>
          <div className="h-container">
              <div className="h-left">
                  <img src={kidan} alt="kidan" />
                  <div className="blur" style={{zIndex:1000}}></div>
              </div>
              <div className="h-right">
                  <div className='type' style={{fontFamily:"Nice"}}>
                      <Typical
                          steps={[
                              'I am Gebrekidan Mequanint', 1000,
                              'Full stack developer', 1000,
                              'Graphic designer', 1000,
                              'Video editor', 1000,                         
                      ]}
                          loop={Infinity}
                          wrapper='h1'
                      />
                       
                  </div>
                 
                  <p>
                      A highly skilled and motivated website designer with expertise in HTML, CSS, JavaScript, React JS, React Native, MongoDB, Express JS, Node JS, PHP, and MySQL. Proficient in graphic design tools such as Adobe Illustrator and Adobe Photo-shop.
                  </p>
                  <a href={doc} className='button' style={{ textDecoration: "none" }} download>Get Resume</a>
                  <div className="link">
                      <a href='https://t.me/widassie'><FaTelegramPlane /></a>
                      <a href="https://github.com/kidanGebre"><VscGithubInverted /></a>
                      <a href="https://www.facebook.com/Dnwidassie"><FaFacebookF/></a>
                  </div>
              </div>
          </div>
          
          
      </div>
  )
}

export default Home